import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  changeHandler,
  setPickUpNotes,
  setCurrentStep,
  disableGoToNextStep,
  stepEnum,
  getPickUpDeliveryTimeSlots,
  clearPickUpSlots,
  formName,
  notificationType,
  saveSelectedPickUpSlot,
  createPickUpNotification,
  dispatchType,
  saveToHistory,
} from "../IMEIDeviceRepairSlice";
import Title from "../Shared/Title";
import AddressFrm from "../../../Shared/AddressFrm/AddressFrm";
import TimeSlotSelection from "../Shared/TimeSlotSelection";
import BtnSubmit from "../../../Shared/Buttons/BtnSubmit";
import PickupDeliveryContactPerson from "./../Shared/PickupDeliveryContactPerson";
import { convertSlotDataToDlvDate } from "../../../../utilities/StringHelpers/StringHelpers";
import AlertIcon from './../images/small-alert.svg';
import {
  dwhPrivateDeliveryAddressPageButtonClick,
  dwhPrivateDeliveryAddressPageDisplayed
} from "app/Components/Block/IMEIDeviceRepairBlock/reports/dwhReports";
const PickUpAddressSelection = (props) => {
  const [getSlotsButton, activateGetSlotsButton] = useState(false);
  const {selectedAccountOrgName, causeList, selectedIMEI, alternatePhone, deliveryPrice, dwhData, securityCode} = props.deviceRepairData;
  const {selectedHetPay, customerName, subscriber} = dwhData;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    dwhPrivateDeliveryAddressPageDisplayed({
      selectedHetPay,
      subscriber,
      selectedIMEI,
      causeList,
      alternatePhone,
      securityCode,
      deliveryPrice,
      customerName,
      selectedAccountOrgName
    })
    props.saveToHistory("pickup");
  }, []);

  useEffect(() => {
    if (
      props.deviceRepairData.pickUpTicketNumber &&
      props.deviceRepairData.goToNextStep
    ) {
      async function saveToHistoryAndContinue() {
        await props.disableGoToNextStep(); //browser back button
        await props.saveToHistory();
        props.setCurrentStep(stepEnum.DELIVERY_ADDRESS);
      }
      saveToHistoryAndContinue();
    }
  }, [props.deviceRepairData.pickUpTicketNumber]);

  useEffect(() => {
    if (
      props.addressForm.form.city &&
      props.addressForm.form.street &&
      props.addressForm.form.home
    ) {
      activateGetSlotsButton(true);
      if (validateAddressChanges()) {
        props.clearPickUpSlots();
      }
    } else {
      props.clearPickUpSlots();
      activateGetSlotsButton(false);
    }
  }, [
    props.addressForm.form.city,
    props.addressForm.form.street,
    props.addressForm.form.home,
  ]);

  function handleInputChange(e) {
    const name = e.target.getAttribute("name");
    const rule = props.deviceRepairData.pickUpAddressForm.rules[name];
    const value = e.target.value;
    const form = formName.pickUpAddressForm;

    props.changeHandler({
      name,
      value,
      rule,
      form,
    });
  }

  const submitPickupAddress = () => {
    if (validateRequest()) {
      dwhPrivateDeliveryAddressPageButtonClick({
        selectedHetPay,
        subscriber,
        selectedIMEI,
        causeList,
        alternatePhone,
        securityCode,
        deliveryPrice,
        customerName,
        selectedAccountOrgName
      })
      const createNotReq = {
        selectedNumber: props.deviceRepairData.selectedPhoneNumber,
        street: props.addressForm.form.streetName,
        city: props.addressForm.form.cityName,
        houseNum: props.addressForm.form.home,
        apartmentNum: props.addressForm.form.apartment,
        contactPersonName:
          props.deviceRepairData.pickUpAddressForm.pickUpContactName,
        contactPersonLastName:
          props.deviceRepairData.pickUpAddressForm.pickUpContactLastName,
        contactPersonPhone:
          props.deviceRepairData.pickUpAddressForm.pickUpContactPhone,
        notes: props.deviceRepairData.pickUpAddressForm.pickUpNotes,
        refOrder: props.deviceRepairData.createNotificationTicketNumber,
        pickUpRefOrder: props.deviceRepairData.pickUpTicketNumber,
        dispLidRsn: `${props.deviceRepairData.pickUpAddressForm.pickUpTimeSlot.waitFrom}-${props.deviceRepairData.pickUpAddressForm.pickUpTimeSlot.waitTo}`,
        dlvDate: convertSlotDataToDlvDate(
          props.deviceRepairData.pickUpAddressForm.pickUpTimeSlot.lfdat,
        ),
        shipCond: props.deviceRepairData.pickUpAddressForm.pickUpTimeSlot.round,
        notificationType: notificationType.PICKUP,
        pickLocation:
          props.deviceRepairData.pickUpAddressForm.pickUpTimeSlot.pickLocation,
        lockCode: props.deviceRepairData.selectCauseForm.securityCode,
        alternatePhone: props.deviceRepairData.selectCauseForm.alternatePhone,
        clearContent: props.deviceRepairData.selectCauseForm.clearContent,
        isPrivate: props.deviceRepairData.isPrivate,
        isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value == true
      };
      props.saveToHistory();
      props.createPickUpNotification(createNotReq);
    }
  };

  const validateAddressChanges = () => {
    if (
      props.deviceRepairData.pickUpAddressForm.city &&
      props.deviceRepairData.pickUpAddressForm.city !=
        props.addressForm.form.cityName
    ) {
      return true;
    } else if (
      props.deviceRepairData.pickUpAddressForm.street &&
      props.deviceRepairData.pickUpAddressForm.street !=
        props.addressForm.form.streetName
    ) {
      return true;
    }
    if (
      props.deviceRepairData.pickUpAddressForm.homeNum &&
      props.deviceRepairData.pickUpAddressForm.homeNum !=
        props.addressForm.form.home
    ) {
      return true;
    } else return false;
  };

  const validateRequest = () => {
    let validForm = true;
    if (!props.deviceRepairData.pickUpAddressForm.pickUpContactName.trim()) {
      props.changeHandler({
        name: "pickUpContactName",
        value: "",
        rule: props.deviceRepairData.pickUpAddressForm.rules.pickUpContactName,
        form: formName.pickUpAddressForm,
      });
      validForm = false;
    }
    if (
      !props.deviceRepairData.pickUpAddressForm.pickUpContactLastName.trim()
    ) {
      props.changeHandler({
        name: "pickUpContactLastName",
        value: "",
        rule: props.deviceRepairData.pickUpAddressForm.rules
          .pickUpContactLastName,
        form: formName.pickUpAddressForm,
      });
      validForm = false;
    }
    if (!props.deviceRepairData.pickUpAddressForm.pickUpContactPhone.trim()) {
      props.changeHandler({
        name: "pickUpContactPhone",
        value: "",
        rule: props.deviceRepairData.pickUpAddressForm.rules.pickUpContactPhone,
        form: formName.pickUpAddressForm,
      });
      validForm = false;
    }
    if (!props.deviceRepairData.pickUpAddressForm.pickUpTimeSlot) {
      props.changeHandler({
        name: "pickUpTimeSlot",
        value: null,
        rule: props.deviceRepairData.pickUpAddressForm.rules.pickUpTimeSlot,
        form: formName.pickUpAddressForm,
      });
      validForm = false;
    }

    return validForm;
  };

  const getTimeSlots = () => {
    const req = {
      city: props.addressForm.form.cityName,
      street: props.addressForm.form.streetName,
      homeNum: props.addressForm.form.home,
      apartmentNum: props.addressForm.form.apartment,
      dispatchType: dispatchType.RVC,
    };
    props.getPickUpDeliveryTimeSlots(req);
  };

  return (
    <div className="pickup-delivery-address-wrapper">
      <div className={'title-area'}>
        <Title
          text={'תאום שליחות לתיקון מכשיר'}
        />
        <span className={'sub-title'}>
        כתובת לתיאום השליחות <span className={'extra-bold'}>לאיסוף</span>
        </span>
      </div>
      {props.contentData.isFromPrivateSelfcare.value &&
        <div className={'delivery-price-container'}>
          <Image src={AlertIcon} alt={'alert'} className={'alert-icon'} />
          <span className={'delivery-price-text'}>עלות המשלוח: <span
              className={'price'}>{props.deviceRepairData?.deliveryPrice > 0 ? `₪${props.deviceRepairData?.deliveryPrice}` : 'ללא עלות'}</span></span>
        </div>
      }
      <div className="pickup-delivery-form">
        <AddressFrm
            title={'מה הכתובת שלך?'}
            avoidGaReport={true}
            onError={() => props.setCurrentStep(stepEnum.ERROR)}
        />
        <div
            className={` ${
                !getSlotsButton ? "disabled-btn" : ""
            } w-100 d-flex justify-content-center get-slots-button`}
        >
          {props.deviceRepairData.pickUpTimeSlots === null &&
            <BtnSubmit
              text={'המשך'}
              onclick={() => (getSlotsButton ? getTimeSlots() : null)}
            />}
        </div>
        {props.deviceRepairData.pickUpAddressForm.errors?.pickUpTimeSlot && (
          <div className="pickup-delivery-slot-error">
            {props.deviceRepairData.pickUpAddressForm.errors?.pickUpTimeSlot}
          </div>
        )}
        {props.deviceRepairData.pickUpTimeSlots && getSlotsButton && (
          <>
            <TimeSlotSelection
              timeSlots={props.deviceRepairData.pickUpTimeSlots}
              name="selectedPickUpTimeSlot"
              selected={
                props.deviceRepairData.pickUpAddressForm.pickUpTimeSlot?.key
              }
              changeHandler={props.saveSelectedPickUpSlot}
            />
            <PickupDeliveryContactPerson
              form={props.deviceRepairData.pickUpAddressForm}
              contactNameForm={"pickUpContactName"}
              contactLastNameForm={"pickUpContactLastName"}
              contactPhoneForm={"pickUpContactPhone"}
              contactNotesForm={'pickUpNotes'}
              changeHandler={handleInputChange}
            />
            <div className="w-100 d-flex justify-content-center">
              <BtnSubmit text={"אישור"} onclick={() => submitPickupAddress()} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    deviceRepairData: state.iMEIDeviceRepair,
    addressForm: state.addressForm,
  };
};

const mapDispatchToProps = {
  setPickUpNotes,
  changeHandler,
  setCurrentStep,
  disableGoToNextStep,
  getPickUpDeliveryTimeSlots,
  clearPickUpSlots,
  saveSelectedPickUpSlot,
  createPickUpNotification,
  saveToHistory,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PickUpAddressSelection);
